import React, { createContext, useContext, useState } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return ctx;
};

export const SettingsProvider = ({ children }) => {
  // Global app settings (non-persistent across reloads by design)
  const [selectedDataset, setSelectedDataset] = useState('all'); // 'all' | 'count1'..'count5' | 'betfair' | 'espn' | 'byb'
  // Dataset enablement for calculations and displays
  const [enabledDatasets, setEnabledDatasets] = useState({
    count1: true,
    count2: true,
    count3: true,
    count4: true,
    count5: true,
    betfair: true,
    espn: true,
    byb: true,
  });

  const toggleDataset = (key) => {
    setEnabledDatasets((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const setAllDatasets = (flag) => {
    setEnabledDatasets({
      count1: flag,
      count2: flag,
      count3: flag,
      count4: flag,
      count5: flag,
      betfair: flag,
      espn: flag,
      byb: flag,
    });
  };

  const applyEnabledDatasets = (next) => {
    // Expect full object with the same keys
    setEnabledDatasets({
      count1: !!next.count1,
      count2: !!next.count2,
      count3: !!next.count3,
      count4: !!next.count4,
      count5: !!next.count5,
      betfair: !!next.betfair,
      espn: !!next.espn,
      byb: !!next.byb,
    });
  };

  const getEnabledKeys = () => Object.entries(enabledDatasets)
    .filter(([, v]) => !!v)
    .map(([k]) => k);

  const getEnabledCount = () => getEnabledKeys().length;

  const value = {
    selectedDataset,
    setSelectedDataset,
    enabledDatasets,
    toggleDataset,
    setAllDatasets,
    applyEnabledDatasets,
    getEnabledKeys,
    getEnabledCount,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};


